<app-page-bar></app-page-bar>

<app-page>
  <!-- A new client (/light-entrepreneur-clients/new) is an empty object: it
       has an id only once saved, as ClientPeerService.save() decides too. -->
  <mat-card *ngIf="client$ | async as client">
    <mat-card-title>
      <h2>{{client.id ? client.name : "New Light Entrepreneur Client"}}</h2>
    </mat-card-title>
    <mat-card-subtitle *ngIf="client.id">
      Created {{client.created_at|date}}
    </mat-card-subtitle>


    <mat-card-content>
      <section>

        <h3>Information</h3>

        <div class="info-grid" *ngIf="countries$ | async as countries">
          <!-- Basic Information Section -->
          <app-text label="Name">{{client.name}}</app-text>
          <app-text label="Personal ID">{{client.personal_id}}</app-text>
          <app-text label="Invoicing Service Company Business ID">{{client.invoicing_service_company_business_id}}</app-text>
          <app-text label="Country">{{countries.get(client.country)?.name}}</app-text>

          <mat-divider></mat-divider>

          <!-- Financial Information Section -->
          <app-text label="Credit Limit">{{ client.credit_limit?.limit.amount | currency:'EUR' }}</app-text>
          <app-text label="Credit Limit Updated">{{ (client.credit_limit?.checked_at | date:'shortDate') || 'Never' }}</app-text>

          <mat-divider></mat-divider>

          <!-- Lead Information Section -->
          <app-text label="Lead Source">{{ client.lead_source?.name || '-' }}</app-text>
          <app-text label="Responsible Seller">{{ client.responsible_seller?.name || '-' }}</app-text>
        </div>
        <div class="form-actions">
            <button type="button" mat-button color="primary" (click)="openEditDialog()">Edit</button>
        </div>

      </section>

      <section *ngIf="client.id && documents$ | async as documents">
        <h3>Client Documents</h3>

        <mat-nav-list *ngIf="documentTypes$ | async as documentTypes">
          <mat-list-item (click)="downloadClientDocument(doc)" *ngFor="let doc of documents">
            <mat-icon mat-list-icon>description</mat-icon>
            <h4 mat-line>{{doc.name || doc.type_description}}</h4>
            <div mat-line>{{doc.filename}}</div>
            <div mat-line>{{doc.notes}}</div>
            <div mat-line>{{doc.created_at | date:'short'}}</div>
            <div mat-line>Signing status: {{doc.signing_status}}</div>
            <button mat-icon-button (click)="$event.stopPropagation()" #trigger=matMenuTrigger
                    [matMenuTriggerFor]="docMenu" [matMenuTriggerData]="{doc: doc}">
              <mat-icon>more_vert</mat-icon>
            </button>
          </mat-list-item>
          <mat-menu #docMenu="matMenu">
            <ng-template matMenuContent let-doc="doc">
              <ng-container *ngIf="!doc.signed_document">
                <button mat-menu-item (click)="openSignDocumentRequestDialog(doc)">
                  <mat-icon>approval</mat-icon>
                  <span>Sign</span>
                </button>
              </ng-container>
              <ng-container *ngIf="doc.signed_document">
                <button mat-menu-item (click)="downloadOriginalClientDocument(doc)">
                  <mat-icon>download</mat-icon>
                  <span>Download Original</span>
                </button>
              </ng-container>
              <ng-container *ngIf="canSendSignal(doc)">
                <button mat-menu-item (click)="remindSigners(doc)">
                  <mat-icon>campaign</mat-icon>
                  <span>Send Signing Reminder</span>
                </button>
              </ng-container>
              <ng-container *ngIf="canSendSignal(doc)">
                <button mat-menu-item (click)="cancelDocumentSigning(doc)">
                  <mat-icon>cancel</mat-icon>
                  <span>Cancel Signing Process</span>
                </button>
              </ng-container>
              <button mat-menu-item (click)="$event.stopPropagation()" [matMenuTriggerFor]="docTypeMenu"
                      [matMenuTriggerData]="{doc: doc}">
                <mat-icon>label</mat-icon>
                <span>Change Type</span>
              </button>
              <button mat-menu-item (click)="confirmDeleteClientDocument(doc)">
                <mat-icon>delete</mat-icon>
                <span>Delete</span>
              </button>
            </ng-template>
          </mat-menu>
          <mat-menu #docTypeMenu="matMenu">
            <ng-template matMenuContent let-doc="doc">
              <button mat-menu-item *ngFor="let docType of documentTypes"
                      (click)="changeClientDocumentType(doc, docType)">
                <span>{{ docType.description }}</span>
              </button>
            </ng-template>
          </mat-menu>
        </mat-nav-list>
        <div>
          <div class="drop-zone" appFileUpload (fileAdded)="clientDocumentFileAdded(client, $event)">
            <mat-icon>cloud_upload</mat-icon>
            <div>
              <p>Drag and drop files here</p>
            </div>
          </div>
        </div>
      </section>
      <section>
        <h3>History</h3>
        <app-client-history></app-client-history>
      </section>
    </mat-card-content>
  </mat-card>

</app-page>
